import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { ThemeProvider } from "@mui/material";
import config from "../../config";
import { getTheme } from "../../theme";

export default function DashboardLayout({ children }) {
  const theme = getTheme(config.themeColor); // Apply theme from config
  return (
    <ThemeProvider theme={theme}>
      <div
        className="flex w-full"
        style={{
          backgroundColor: "#000",
          backgroundImage: "url('./assets/dashboard-bg.png')",
          backgroundSize: "cover",
        }}
      >
        <Sidebar />
        <div className="flex flex-col w-full">
          <Header />
          <div className="content-wrapper">{children}</div>
        </div>
      </div>
      <Footer />
    </ThemeProvider>
  );
}
